// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".divider[data-v-39e89e51]{width:100%;height:1px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
